export default __webpack_public_path__ + "static/media/panda.28ec4c7d.webp";